class TradeProgramRegister {
    constructor() {
        this.triggerSelector = 'a[href="/pages/affiliate-program"]';
        this.modalId = 'affiliate-program-register-modal';
        this.apiProxyUrl = '/apps/spry-tool/affiliate-consumer-register';
        this.allowCheckEmail = true;
        // this.apiProxyUrl = 'https://gotten-gary-asbestos-interesting.trycloudflare.com/proxy/spry-tool/affiliate-consumer-register?shop=test-app-bach.myshopify.com';
        this.totalSteps = 3;
        this.currentStep = 1;

        if (!document.body.classList.contains('template-page-affiliate-program')) return;

        this.renderModal();
        this.modal = document.getElementById(this.modalId);
        this.form = this.modal.querySelector('form');

        this.bindTriggers();
        this.bindCloseEvents();
        this.bindSubmit();
        this.bindSteps();
        this.bindSelects();
        this.bindFileUpload();

        this.form.querySelectorAll('.custom-select').forEach((select) => this.updateSelectLabel(select));
    }

    stepFields() {
        return {
            1: {
                title: 'Contact Information',
                intro: `Join the <strong>ET Woodcrafts Affiliate Program</strong>\nShare thoughtfully handcrafted furniture with your audience or clients and earn up to 20% commission on eligible referred sales.\nComplete this short application and provide links to your social media channels, website, portfolio, or other platforms that demonstrate your ability to introduce ET Woodcrafts products.\nMost applications are reviewed within a few business days.`,
                html: `
                    <div class="field-row">
                        <div class="field">
                            <label for="ap-first-name">First Name<span aria-hidden="true">*</span></label>
                            <input type="text" id="ap-first-name" name="first_name" placeholder="Enter your first name" required autocomplete="given-name">
                        </div>
                        <div class="field">
                            <label for="ap-last-name">Last Name<span aria-hidden="true">*</span></label>
                            <input type="text" id="ap-last-name" name="last_name" placeholder="Enter your last name" required autocomplete="family-name">
                        </div>
                    </div>
                    <div class="field-row">
                        <div class="field">
                            <label for="ap-email">Email Address<span aria-hidden="true">*</span></label>
                            <input type="email" id="ap-email" name="email" placeholder="example@gmail.com" required autocomplete="email">
                        </div>
                        <div class="field">
                            <label for="ap-phone">Phone Number</label>
                            <input type="tel" id="ap-phone" name="phone" placeholder="Enter your phone number" autocomplete="tel">
                        </div>
                    </div>
                    <div class="field">
                        <label for="ap-country">Country or Region<span aria-hidden="true">*</span></label>
                        <select id="ap-country" name="country" required>
                            <option value="" selected disabled>Select one</option>
                            <option value="United States">United States</option>
                            <option value="Canada">Canada</option>
                            <option value="United Kingdom">United Kingdom</option>
                            <option value="European Union">European Union</option>
                            <option value="Australia">Australia</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div class="field">
                        <label for="ap-brand-name">Brand, Channel or Creator Name</label>
                        <input type="text" id="ap-brand-name" name="brand_name" placeholder="Enter your brand, channel or creator name">
                    </div>
                    <div class="field">
                        <label for="ap-describes-you">Which option best describes you?<span aria-hidden="true">*</span></label>
                        ${this.selectTagMarkup('ap-describes-you', 'describes_you', 'Select one', [
                            'KOL', 'KOC', 'Influencer', 'Content Creator', 'Blogger or Publisher',
                            'Social Media Page Owner', 'Affiliate Marketer', 'Other'
                        ], { required: true })}
                    </div>
                `
            },
            2: {
                title: 'Professional Profile',
                html: `
                    <div class="field">
                        <label>What type of content do you primarily create?<span aria-hidden="true">*</span></label>
                        ${this.selectMarkup('content_type', 'Select all that apply', [
                            'Furniture', 'Home Décor', 'Interior Styling', 'Home Improvement', 'Lifestyle',
                            'Home Organization', 'DIY', 'Real Estate', 'Art and Craftsmanship',
                            'Product Reviews', 'Shopping and Product Recommendations', 'Other'
                        ], { required: true })}
                    </div>
                    <div class="field">
                        <label for="ap-primary-link">Primary Social Media, Website, or Portfolio Link<span aria-hidden="true">*</span></label>
                        <input type="url" id="ap-primary-link" name="primary_link" placeholder="Enter URL" required>
                        <p class="field-hint">Please provide the main public channel you plan to use to promote ET Woodcrafts. <br>Examples: Include Instagram, TikTok, YouTube, Pinterest, Facebook, a website, blog, newsletter, or other public content platform.</p>
                    </div>
                    <div class="field">
                        <label for="ap-additional-links">Additional Channel Links</label>
                        <input type="url" id="ap-additional-links" name="additional_links" placeholder="Enter URL">
                        <p class="field-hint">You may include additional social media accounts, websites, blogs, newsletters, or content channels. Please enter one link per line.</p>
                    </div>
                    <div class="field">
                        <label>Upload a Media Kit or Portfolio</label>
                        <div class="file-upload" tabindex="0" role="button" aria-label="Upload a media kit or portfolio">
                            <input type="file" id="ap-media-kit" name="media_kit" accept=".jpeg,.jpg,.png,.pdf" hidden>
                            <div class="file-upload__icon" aria-hidden="true">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" stroke="#CE6506" stroke-width="1.4"/><path d="M14 2v5h5" stroke="#CE6506" stroke-width="1.4"/></svg>
                            </div>
                            <p class="file-upload__text">Drag and drop your files</p>
                            <p class="file-upload__hint">JPEG, PNG, PDF, up to 10MB</p>
                            <button type="button" class="button button--secondary file-upload__button">Select File</button>
                            <p class="file-upload__filename" hidden></p>
                        </div>
                    </div>
                    <div class="field">
                        <label for="ap-audience-reach">What is your approximate audience or client reach?</label>
                        ${this.selectTagMarkup('ap-audience-reach', 'audience_reach', 'Select one (optional)', [
                            'Under 1,000', '1,000 - 5,000', '5,001 - 10,000', '10,001 - 50,000',
                            '50,001 - 100,000', 'Over 100,000'
                        ], { required: false })}
                    </div>
                    <div class="field">
                        <label>Where is your primary audience or client base located?<span aria-hidden="true">*</span></label>
                        ${this.selectMarkup('audience_location', 'Select all that apply', [
                            'United States', 'Canada', 'United Kingdom', 'European Union', 'Australia', 'Other'
                        ], { required: true })}
                    </div>
                    <div class="field">
                        <label for="ap-audience-description">Briefly describe your audience</label>
                        <input type="url" id="ap-audience-description" name="audience_description" placeholder="">
                        <p class="field-hint">Tell us about your audience's interests, location, age range, shopping behavior, or connection to furniture, home décor, lifestyle, or home improvement content.</p>
                        
                    </div>
                `
            },
            3: {
                title: 'Promotion Plan',
                html: `
                    <div class="field">
                        <label>How do you plan to promote or recommend ET Woodcrafts?<span aria-hidden="true">*</span></label>
                        ${this.selectMarkup('promotion_plan', 'Select all that apply', [
                            'Social media posts', 'Instagram Reels', 'TikTok videos', 'YouTube Shorts',
                            'Long-form YouTube videos', 'Product reviews', 'Unboxing content',
                            'Home styling content', 'Product recommendation content', 'Blog or editorial articles',
                            'Website features', 'Email newsletters', 'Livestream content', 'Paid advertising', 'Other'
                        ], { required: true })}
                    </div>
                    <div class="field">
                        <label for="ap-intro-plan">Briefly describe how you plan to introduce ET Woodcrafts to your audience<span aria-hidden="true">*</span></label>
                        <textarea id="ap-intro-plan" name="intro_plan" rows="3" placeholder="Tell us what type of content, project, or promotional activity you plan to create and where you plan to share your referral link." required></textarea>
                    </div>
                    <div class="field">
                        <label for="ap-previous-work">Please share examples of previous work or brand collaborations</label>
                        <input type="text" id="ap-previous-work" name="previous_work" placeholder="You may provide links to relevant content, design projects, product features, campaigns, reviews, or previous partnerships">
                    </div>
                    <div class="field">
                        <label for="ap-previous-affiliate">Have you previously participated in an affiliate or referral program?</label>
                        ${this.selectTagMarkup('ap-previous-affiliate', 'previous_affiliate', 'Select one (optional)', ['Yes', 'No'], { required: false })}
                    </div>
                    <div class="field">
                        <label>Which product categories are you most interested in promoting?</label>
                        ${this.selectMarkup('product_categories', 'Select all that apply (optional)', [
                            'Coffee Tables', 'Dining Tables', 'Console Tables', 'TV Stands and Media Consoles',
                            'Bookshelves', 'Cabinets and Storage', 'Bedroom Furniture', 'Home Décor',
                            'Outdoor Furniture', 'Other'
                        ], { required: false })}
                    </div>
                    <div class="field">
                        <label for="ap-feature-frequency">How frequently do you expect to feature ET Woodcrafts?</label>
                        ${this.selectTagMarkup('ap-feature-frequency', 'feature_frequency', 'Select one (optional)', [
                            'Several times per month', 'Once per month', 'Once every few months',
                            'During relevant campaigns or seasonal events', 'Not sure yet'
                        ], { required: false })}
                    </div>
                    <div class="field">
                        <label for="ap-hear-about">How did you hear about the ET Woodcrafts Affiliate Program?</label>
                        ${this.selectTagMarkup('ap-hear-about', 'hear_about', 'Select one (optional)', [
                            'ET Woodcrafts Website', 'Instagram', 'Facebook', 'TikTok', 'Pinterest',
                            'Google', 'Email', 'Friend or Business Partner', 'Other'
                        ], { required: false })}
                    </div>
                    <div class="field">
                        <label>1. Please confirm the following<span aria-hidden="true">*</span></label>
                        <div class="checkbox-list">
                            <label class="checkbox-list__item"><input type="checkbox" name="confirm_accurate" required><span>I confirm that the information provided in this application is accurate.</span></label>
                            <label class="checkbox-list__item"><input type="checkbox" name="confirm_authorized" required><span>I confirm that I own, manage, or am authorized to represent the submitted channels.</span></label>
                            <label class="checkbox-list__item"><input type="checkbox" name="confirm_honest" required><span>I agree to represent ET Woodcrafts products honestly and accurately.</span></label>
                            <label class="checkbox-list__item"><input type="checkbox" name="confirm_disclose" required><span>I agree to disclose affiliate or sponsored relationships where required.</span></label>
                            <label class="checkbox-list__item"><input type="checkbox" name="confirm_no_fake" required><span>I agree not to generate fake traffic, clicks, referrals, engagement, or orders.</span></label>
                            <label class="checkbox-list__item"><input type="checkbox" name="confirm_terms" required><span>I agree to follow the ET Woodcrafts Affiliate Program Terms and Policies.</span></label>
                            <label class="checkbox-list__item"><input type="checkbox" name="confirm_no_guarantee" required><span>I understand that submitting an application does not guarantee approval.</span></label>
                            <label class="checkbox-list__item"><input type="checkbox" name="confirm_privacy" required><span>I agree to ET Woodcrafts's Privacy Policy.</span></label>
                        </div>
                    </div>
                    <div class="field">
                        <label>2. Email Updates <span class="field-optional">(optional)</span></label>
                        <div class="checkbox-list">
                            <label class="checkbox-list__item"><input type="checkbox" name="email_updates"><span>I would like to receive Affiliate Program updates, product launches, campaign opportunities, and brand news from ET Woodcrafts.</span></label>
                        </div>
                    </div>
                `
            }
        };
    }

    selectTagMarkup(id, name, placeholder, options, { required }) {
        const optionsHtml = options.map((opt) => `<option value="${opt}">${opt}</option>`).join('');

        return `
            <select id="${id}" name="${name}" ${required ? 'required' : ''}>
                <option value="" selected disabled>${placeholder}</option>
                ${optionsHtml}
            </select>
        `;
    }

    selectMarkup(name, placeholder, options, { required }) {
        const optionsHtml = options.map((opt) => `
            <label class="custom-select__option">
                <input type="checkbox" name="${name}[]" value="${opt}">
                <span>${opt}</span>
            </label>
        `).join('');

        return `
            <div class="custom-select" data-name="${name}" data-required="${required ? 'true' : 'false'}">
                <button type="button" class="custom-select__trigger" aria-haspopup="listbox" aria-expanded="false">
                    <span class="custom-select__placeholder">${placeholder}</span>
                    <svg class="custom-select__chevron" width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5l5 5 5-5" stroke="#4C3514" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>
                <div class="custom-select__panel" role="listbox">${optionsHtml}</div>
                <p class="custom-select__error" hidden>Please select at least one option.</p>
            </div>
        `;
    }

    stepIndicatorMarkup() {
        const steps = [
            { n: 1, label: 'Step 1', sublabel: 'Contact Information' },
            { n: 2, label: 'Step 2', sublabel: 'Professional Profile' },
            { n: 3, label: 'Step 3', sublabel: 'Promotion Plan' }
        ];
        const chevron = `
            <span class="step-indicator__chevron" aria-hidden="true">
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l6 6-6 6" stroke="#CFD6DC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
        `;
        return `
            <div class="affiliate-program-register-modal__steps">
                ${steps.map((s, i) => `
                    ${i > 0 ? chevron : ''}
                    <div class="step-indicator__item" data-step-indicator="${s.n}">
                        <span class="step-indicator__item-row">
                            <span class="step-indicator__marker">${s.n}</span>
                            <span class="step-indicator__text">
                                <span class="step-indicator__label">${s.label}</span>
                                <span class="step-indicator__sublabel">${s.sublabel}</span>
                            </span>
                        </span>
                        <span class="step-indicator__underline"></span>
                    </div>
                `).join('')}
            </div>
        `;
    }

    renderModal() {
        if (document.getElementById(this.modalId)) return;

        const fields = this.stepFields();
        this.stepIntros = {};
        const stepsHtml = Object.keys(fields).map((n) => {
            this.stepIntros[n] = fields[n].intro || '';
            return `
            <div class="form-step" data-step="${n}" hidden>
                ${fields[n].html}
            </div>
        `;
        }).join('');

        const wrapper = document.createElement('div');
        wrapper.innerHTML = `
        <div id="${this.modalId}" class="affiliate-program-register-modal" role="dialog" aria-modal="true" hidden>
            <div class="affiliate-program-register-modal__inner">
                <button type="button" class="affiliate-program-register-modal__close" aria-label="Close">&times;</button>
                <h3 class="affiliate-program-register-modal__title">ET WOODCRAFTS AFFILIATE PROGRAM APPLICATION</h3>
                ${this.stepIndicatorMarkup()}
                <div class="affiliate-program-register-modal__intro"></div>
                <form class="affiliate-program-register-modal__form" novalidate>
                    <div class="affiliate-program-register-modal__step-content">${stepsHtml}</div>
                    <p class="affiliate-program-register-modal__message" role="status" hidden></p>
                    <div class="affiliate-program-register-modal__actions">
                        <button type="button" class="button button--secondary affiliate-program-register-modal__prev" hidden>Previous</button>
                        <button type="button" class="button button--primary affiliate-program-register-modal__next">Next</button>
                        <button type="submit" class="button button--primary affiliate-program-register-modal__submit" hidden>Submit</button>
                    </div>
                </form>
            </div>
        </div>`;

        document.body.appendChild(wrapper.firstElementChild);
    }

    bindTriggers() {
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest(this.triggerSelector);
            if (!trigger) return;
            e.preventDefault();
            this.openModal();
        });
    }

    bindCloseEvents() {
        this.modal.addEventListener('click', (e) => {
            if (e.target.closest('.affiliate-program-register-modal__close')) {
                this.closeModal();
                return;
            }
            if (e.target === this.modal) this.closeModal();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !this.modal.hidden) this.closeModal();
        });
    }

    bindSubmit() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.submitForm();
        });
    }

    bindSteps() {
        this.form.querySelector('.affiliate-program-register-modal__next').addEventListener('click', () => this.goNext());
        this.form.querySelector('.affiliate-program-register-modal__prev').addEventListener('click', () => this.goPrev());

        this.form.addEventListener('input', (e) => {
            if (e.target.matches('input[required], select[required], textarea[required]') && e.target.checkValidity()) {
                this.setFieldError(e.target, '');
            }
        });

        this.form.addEventListener('change', (e) => {
            if (e.target.matches('select[required]') && e.target.checkValidity()) {
                this.setFieldError(e.target, '');
            }
            if (e.target.matches('select')) {
                e.target.classList.toggle('has-value', !!e.target.value);
            }
        });
    }

    bindSelects() {
        this.form.addEventListener('click', (e) => {
            const trigger = e.target.closest('.custom-select__trigger');
            if (trigger) {
                const select = trigger.closest('.custom-select');
                const isOpen = select.classList.contains('is-open');
                this.closeAllSelects();
                if (!isOpen) select.classList.add('is-open');
                trigger.setAttribute('aria-expanded', String(!isOpen));
                return;
            }

            const option = e.target.closest('.custom-select__option');
            if (option) {
                const select = option.closest('.custom-select');
                const checkbox = option.querySelector('input');

                if (e.target !== checkbox) {
                    e.preventDefault();
                    checkbox.checked = !checkbox.checked;
                }

                this.updateSelectLabel(select);
                return;
            }

            if (!e.target.closest('.custom-select')) this.closeAllSelects();
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.custom-select')) this.closeAllSelects();
        });
    }

    closeAllSelects() {
        this.form.querySelectorAll('.custom-select.is-open').forEach((select) => {
            select.classList.remove('is-open');
            select.querySelector('.custom-select__trigger').setAttribute('aria-expanded', 'false');
        });
    }

    updateSelectLabel(select) {
        const placeholderEl = select.querySelector('.custom-select__placeholder');
        const defaultText = placeholderEl.dataset.default || placeholderEl.textContent;
        placeholderEl.dataset.default = defaultText;

        const checked = Array.from(select.querySelectorAll('.custom-select__option input:checked')).map((i) => i.value);

        if (checked.length) {
            select.classList.remove('has-error');
            const errorEl = select.querySelector('.custom-select__error');
            if (errorEl) errorEl.hidden = true;
        }

        if (!checked.length) {
            placeholderEl.textContent = defaultText;
            placeholderEl.classList.remove('has-value');
        } else {
            placeholderEl.textContent = checked.join(', ');
            placeholderEl.classList.add('has-value');
        }
    }

    bindFileUpload() {
        this.maxFileSize = 10 * 1024 * 1024;

        this.form.addEventListener('click', (e) => {
            const btn = e.target.closest('.file-upload__button');
            const zone = e.target.closest('.file-upload');
            if (btn || (zone && e.target === zone)) {
                const input = this.form.querySelector('#ap-media-kit');
                if (input) input.click();
            }
        });

        this.form.addEventListener('change', (e) => {
            if (e.target.id !== 'ap-media-kit') return;
            const zone = e.target.closest('.file-upload');
            const filenameEl = zone.querySelector('.file-upload__filename');
            const file = e.target.files[0];

            if (file && file.size > this.maxFileSize) {
                this.setFieldError(e.target, `${file.name} is too large. Please upload a file up to 10MB.`);
                e.target.value = '';
                filenameEl.textContent = '';
                filenameEl.hidden = true;
                return;
            }

            this.setFieldError(e.target, '');
            filenameEl.textContent = file ? file.name : '';
            filenameEl.hidden = !file;
        });
    }

    renderStep() {
        this.form.className = this.form.className.replace(/\bstep-\d+\b/g, '').trim();
        this.form.classList.add(`step-${this.currentStep}`);

        const introEl = this.modal.querySelector('.affiliate-program-register-modal__intro');
        let introText = '';

        this.form.querySelectorAll('.form-step').forEach((panel) => {
            const n = parseInt(panel.dataset.step, 10);
            const isCurrent = n === this.currentStep;
            panel.hidden = !isCurrent;
            if (isCurrent) introText = this.stepIntros[n] || '';
        });

        introEl.innerHTML = introText
            ? introText.split('\n').map((line) => `<p>${line}</p>`).join('')
            : '';
        introEl.hidden = !introText;

        this.modal.querySelectorAll('.step-indicator__item').forEach((el) => {
            const n = parseInt(el.dataset.stepIndicator, 10);
            el.classList.toggle('is-active', n === this.currentStep);
            el.classList.toggle('is-complete', n < this.currentStep);
        });

        const prevBtn = this.form.querySelector('.affiliate-program-register-modal__prev');
        const nextBtn = this.form.querySelector('.affiliate-program-register-modal__next');
        const submitBtn = this.form.querySelector('.affiliate-program-register-modal__submit');

        prevBtn.hidden = this.currentStep === 1;
        const isLastStep = this.currentStep >= this.totalSteps;
        nextBtn.hidden = isLastStep;
        submitBtn.hidden = !isLastStep;
    }

    fieldLabelText(input) {
        const field = input.closest('.field') || input.parentElement;
        const label = (input.id && this.form.querySelector(`label[for="${input.id}"]`)) || field.querySelector('label');
        if (!label) return 'this field';
        return label.textContent.replace(/\*$/, '').trim();
    }

    fieldErrorMessage(input) {
        const labelText = this.fieldLabelText(input);
        if (input.validity.valueMissing) return `Please fill out ${labelText}.`;
        if (input.validity.typeMismatch || input.validity.patternMismatch) {
            if (input.type === 'email') return `Please enter a valid email address for ${labelText}.`;
            if (input.type === 'url') return `Please enter a valid URL for ${labelText}.`;
            return `Please enter a valid value for ${labelText}.`;
        }
        return input.validationMessage || `Please fill out ${labelText}.`;
    }

    setFieldError(input, message) {
        const field = input.closest('.field') || input.parentElement;
        let errorEl = field.querySelector('.field__error');
        if (!errorEl) {
            errorEl = document.createElement('p');
            errorEl.className = 'field__error';
            field.appendChild(errorEl);
        }
        errorEl.textContent = message || '';
        errorEl.hidden = !message;
        input.classList.toggle('has-error', !!message);

        const uploadZone = field.querySelector('.file-upload');
        if (uploadZone) uploadZone.classList.toggle('has-error', !!message);
    }

    validateStep() {
        const contentEl = this.form.querySelector(`.form-step[data-step="${this.currentStep}"]`) || this.form;
        const requiredInputs = contentEl.querySelectorAll('input[required], select[required], textarea[required]');
        let firstInvalidInput = null;
        for (const input of requiredInputs) {
            if (!input.checkValidity()) {
                this.setFieldError(input, this.fieldErrorMessage(input));
                if (!firstInvalidInput) firstInvalidInput = input;
            } else {
                this.setFieldError(input, '');
            }
        }

        if (firstInvalidInput) {
            firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return false;
        }

        let firstInvalidSelect = null;
        const requiredSelects = contentEl.querySelectorAll('.custom-select[data-required="true"]');
        for (const select of requiredSelects) {
            const hasChecked = select.querySelector('.custom-select__option input:checked');
            const errorEl = select.querySelector('.custom-select__error');
            if (!hasChecked) {
                const field = select.closest('.field');
                const label = field ? field.querySelector('label') : null;
                const labelText = label ? label.textContent.replace(/\*$/, '').trim() : 'this field';
                select.classList.add('has-error');
                errorEl.textContent = `Please fill out ${labelText}.`;
                errorEl.hidden = false;
                if (!firstInvalidSelect) firstInvalidSelect = select;
            } else {
                select.classList.remove('has-error');
                errorEl.hidden = true;
            }
        }

        if (firstInvalidSelect) {
            firstInvalidSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return false;
        }

        return true;
    }

    async goNext() {
        if (!this.validateStep()) return;

        if (this.currentStep === 1) {
            const emailInput = this.form.querySelector('#ap-email');
            const email = emailInput.value.trim();
            const nextBtn = this.form.querySelector('.affiliate-program-register-modal__next');

            nextBtn.disabled = true;
            nextBtn.classList.add('is-loading');
            this.setFieldError(emailInput, '');

            try {
                const exists = await this.checkEmail(email);
                if (exists) {
                    this.setFieldError(emailInput, 'This email is already registered. Please use a different email address.');
                    return;
                }
            } catch (err) {
                console.error('Affiliate program email check failed', err);
                this.setFieldError(emailInput, 'Something went wrong. Please try again.');
                return;
            } finally {
                nextBtn.disabled = false;
                nextBtn.classList.remove('is-loading');
            }
        }

        this.currentStep += 1;
        this.renderStep();
    }

    async checkEmail(email) {
        if (!this.allowCheckEmail) return false;
        const separator = this.apiProxyUrl.includes('?') ? '&' : '?';
        const url = `${this.apiProxyUrl}${separator}check_email=${encodeURIComponent(email)}`;
        const response = await fetch(url, { method: 'GET' });

        if (!response.ok) throw new Error('Request failed');

        const data = await response.json();
        if (!data.ok) throw new Error('Request failed');

        return !!data.exists;
    }

    goPrev() {
        this.currentStep -= 1;
        this.renderStep();
    }

    openModal() {
        this.currentStep = 1;
        this.form.reset();
        this.form.querySelectorAll('.custom-select').forEach((select) => this.updateSelectLabel(select));
        this.form.querySelectorAll('.field__error, .custom-select__error').forEach((el) => { el.hidden = true; });
        this.form.querySelectorAll('.has-error').forEach((el) => el.classList.remove('has-error'));
        this.renderStep();

        this.modal.hidden = false;
        document.body.style.overflow = 'hidden';
    }

    closeModal() {
        this.modal.hidden = true;
        document.body.style.overflow = '';
    }

    setMessage(text, isError) {
        const messageEl = this.form.querySelector('.affiliate-program-register-modal__message');
        messageEl.textContent = text;
        messageEl.hidden = !text;
        messageEl.classList.toggle('affiliate-program-register-modal__message--error', !!isError);
    }

    async submitForm() {
        if (!this.validateStep()) return;

        const submitButton = this.form.querySelector('.affiliate-program-register-modal__submit');
        const formData = new FormData(this.form);
        formData.set('email_updates', this.form.querySelector('[name="email_updates"]').checked ? 'true' : 'false');

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        this.setMessage('', false);

        try {
            const response = await fetch(this.apiProxyUrl, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) throw new Error('Request failed');

            this.showSuccessState();
        } catch (err) {
            console.error('Affiliate program registration failed', err);
            this.setMessage('Something went wrong. Please try again.', true);
        } finally {
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
        }
    }

    showSuccessState() {
        const inner = this.modal.querySelector('.affiliate-program-register-modal__inner');
        inner.innerHTML = `
            <button type="button" class="affiliate-program-register-modal__close" aria-label="Close">&times;</button>
            <h3 class="affiliate-program-register-modal__title">ET Woodcrafts Affiliate Program Application</h3>
            <div class="affiliate-program-register-modal__success">
                <div class="affiliate-program-register-modal__success-icon" aria-hidden="true">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="#CE6506" stroke-width="1.5"/><path d="M7.5 12.5l3 3 6-6.5" stroke="#CE6506" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </div>
                <div>
                    <p class="affiliate-program-register-modal__success-title">Thank you for applying to the ET Woodcrafts Affiliate Program.</p>
                    <p>Our team will review your application, including your content, audience, engagement, and overall fit with ET Woodcrafts.</p>
                    <p>If approved, you'll receive an email with your affiliate details, unique referral link, commission information, and next steps to start promoting ET Woodcrafts.</p>
                </div>
            </div>
        `;
    }
}

document.addEventListener('DOMContentLoaded', () => new TradeProgramRegister());
